import { preloadJson } from "./ui.js";
import { initPaymentIcons } from "./payment-icons";
import { initCookieConsent } from "./consent";
import initReadMore from "./read-more.js";
import { initSearchBar } from "./search-bar";
import { initMainMenu } from "./components/side-menu/MainMenu";
import { initStickyHeader } from "./sticky-header";
import { initModalTriggers } from "./components/modal/Modal";
import { initGATrackingLinks } from "./analytics/ga-event-tracking";
import { initLocalePicker } from "./locale-picker";
import { initLocaleTooltip } from "./locale-tooltip";
import { initFooterAccordions } from "./footer-accordion";

export default function initPage() {
  const { currentCountry, currentLang } = window;
  if (
    !sessionStorage.getItem("currentLang") ||
    !sessionStorage.getItem("currentCountry")
  ) {
    sessionStorage.setItem("currentLang", currentLang);
    sessionStorage.setItem("currentCountry", currentCountry);
  }

  initGATrackingLinks();
  initPaymentIcons();
  preloadJson();
  initCookieConsent();
  initReadMore();
  initSearchBar();
  initStickyHeader();
  initFooterAccordions();
  initLocalePicker();
  initLocaleTooltip();

  initMainMenu();
  initModalTriggers();
}
